// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productsTab{
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100%;
    padding-top: 0;
}
.titleBlock{
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
    justify-content: start;
}
.titleBlock p{
    font-size: 20px;
    margin: 0;
    
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/Tabs/ProductPage/productsTab.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,SAAS;;AAEb","sourcesContent":[".productsTab{\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    width: 100%;\n    padding-top: 0;\n}\n.titleBlock{\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n    justify-content: start;\n}\n.titleBlock p{\n    font-size: 20px;\n    margin: 0;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productsTab": `productsTab`,
	"titleBlock": `titleBlock`
};
export default ___CSS_LOADER_EXPORT___;
